const sharedGdprCookieTypeStyles = {
  "& h4,h5": {
    color: "#37b534",
    fontFamily: "Quicksand,sans-serif",
    fontWeight: 500,
    marginBottom: "10px",
    marginTop: 0
  },
  "& h5": {
    fontSize: "15px"
  },
  "& p,ul": {
    color: "#fff",
    fontSize: "15px",
    lineHeight: "1.5em",
    marginBottom: "20px",
    padding: 0
  },
  "& ul": {
    paddingBottom: "10px",
    margin: 0,
    border: "none"
  },
  "& li": {
    width: "49%",
    display: "inline-block"
  }
};

const cookieAndPrivacyStyle = {
  removeMessage: {
    display: "none"
  },
  gdprCookieMessage: {
    zIndex: 1001,
    opacity: 1,
    visibility: "visible",
    position: "fixed",
    right: "30px",
    bottom: "30px",
    maxWidth: "400px",
    backgroundColor: "#424643",
    padding: "20px",
    borderRadius: "5px",
    boxShadow: "0 6px 6px rgb(0 0 0 / 25%)",
    marginLeft: "30px",
    fontFamily: "system-ui,sans-serif",
    fontSize: "18px",
    height: "auto",
    "& h4,h5": {
      color: "#37b534",
      fontFamily: "Quicksand,sans-serif",
      fontWeight: 500,
      marginBottom: "10px",
      marginTop: 0
    },
    "& p,ul": {
      color: "#fff",
      fontSize: "15px",
      lineHeight: "1.5em",
      marginBottom: "20px",
      padding: 0
    },
    "& a": {
      color: "#37b534",
      textDecoration: "none",
      fontSize: "15px",
      paddingBottom: "2px",
      borderBottom: "1px dotted hsla(0,0%,100%,.75)",
      transition: "all .3s ease-in",
      cursor: "pointer"
    },
    "& p:last-child": {
      marginBottom: 0,
      textAlign: "right"
    },
    "& button": {
      float: "right",
      minWidth: "150px",
      border: "none",
      background: "#37b534",
      color: "#fff",
      fontFamily: "Quicksand,sans-serif",
      fontSize: "15px",
      padding: "7px",
      borderRadius: "3px",
      marginLeft: "15px",
      cursor: "pointer",
      textTransform: "none",
      transition: "all .3s ease-in"
    }
  },
  customiseLink: {
    "&.MuiLink-root": {
      float: "right"
    }
  },
  gdprCookieTypesL: {
    transition: "max-height 0.5s ease-in-out 0.15s",
    overflowY: "hidden",
    maxHeight: "365px",
    ...sharedGdprCookieTypeStyles
  },
  gdprCookieTypes: {
    transition: "max-height 0.5s ease-in-out 0.15s",
    maxHeight: "0px",
    overflow: "hidden",
    ...sharedGdprCookieTypeStyles
  }
};

export default cookieAndPrivacyStyle;
